module.exports = __webpack_public_path__ + "static/media/3fb.529be8b3.jpg";